<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>活动阶段分析</span>
        </div>
        <el-form ref="queryForm" :model="queryParams" :inline="true">
          <el-form-item label="活动ID" label-width="100px">
            <el-autocomplete v-model="queryParams.id" popper-class="my-autocomplete" placeholder="请输入活动ID" :fetch-suggestions="querySearchAsync" clearable size="small" @select="handleSelect" @change="handleChange"><template slot-scope="{ item }">
              <div class="name">{{ item.id }}</div>
              <span class="addr">{{ item.name }}</span>
            </template>
            </el-autocomplete>
          </el-form-item>
          <el-form-item label="日期" prop="startDate" label-width="100px">
            <el-date-picker v-model="dateList" value-format="yyyy-MM-dd" :disabled="dateDisabled" size="small" type="daterange" align="right" start-placeholder="开始日期" end-placeholder="结束日期" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="small" :disabled="tableLoad" @click="handleQuery">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column label="阶段" align="center">
            <template slot-scope="{row,$index}">{{ row.stage }}</template>
          </el-table-column>
          <el-table-column label="停留总人数" align="center">
            <template slot-scope="{row,$index}">{{ row.count }}</template>
          </el-table-column>
          <el-table-column label="0%-10%" align="center">
            <el-table-column label="玩家数" align="center">
              <template slot-scope="{row,$index}">{{ row.p1 }}</template>
            </el-table-column>
            <el-table-column label="占比" align="center">
              <template slot-scope="{row,$index}">{{ row.p1Rate }}</template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="10%-30%" align="center">
            <el-table-column label="玩家数" align="center">
              <template slot-scope="{row,$index}">{{ row.p2 }}</template>
            </el-table-column>
            <el-table-column label="占比" align="center">
              <template slot-scope="{row,$index}">{{ row.p2Rate }}</template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="30%-50%" align="center">
            <el-table-column label="玩家数" align="center">
              <template slot-scope="{row,$index}">{{ row.p3 }}</template>
            </el-table-column>
            <el-table-column label="占比" align="center">
              <template slot-scope="{row,$index}">{{ row.p3Rate }}</template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="50%-80%" align="center">
            <el-table-column label="玩家数" align="center">
              <template slot-scope="{row,$index}">{{ row.p4 }}</template>
            </el-table-column>
            <el-table-column label="占比" align="center">
              <template slot-scope="{row,$index}">{{ row.p4Rate }}</template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="80%-90%" align="center">
            <el-table-column label="玩家数" align="center">
              <template slot-scope="{row,$index}">{{ row.p5 }}</template>
            </el-table-column>
            <el-table-column label="占比" align="center">
              <template slot-scope="{row,$index}">{{ row.p5Rate }}</template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="90%-100%" align="center">
            <el-table-column label="玩家数" align="center">
              <template slot-scope="{row,$index}">{{ row.p6 }}</template>
            </el-table-column>
            <el-table-column label="占比" align="center">
              <template slot-scope="{row,$index}">{{ row.p6Rate }}</template>
            </el-table-column>
          </el-table-column>
        </el-table>

      </el-card>
    </template>

  </BasicLayout>
</template>

<script>

import { getActivtyList } from '@/api/config/activity-cfg'
import { Message } from 'element-ui'
import { getActStageStat } from '@/api/user/user_info'
import { delCfg } from '@/api/config/send-notice'

export default {
  name: 'ActStage',
  data() {
    return {
      pickerOptions: {
        disabledDate: time => time.getTime() > Date.now() // 可选择今天以前的日期
      },
      queryParams: {
        name: '',
        id: '',
        lang: '',
        count: 0,
        startDate: '',
        endDate: ''
      },
      loading: false,
      dateDisabled: true,
      payEvent: false,
      allUserEvent: false,
      tableLoad: false,
      aid: '',
      tableData: [],
      dateList: []
    }
  },
  created() {
    this.dateList = []
  },
  methods: {
    fetchData() {
      this.queryParams.type = 0
      getActStageStat(this.queryParams).then(response => {
        if (response.data.data === null || response.data.data.length === 0) {
          if (response.data.count === 0) {
            this.$confirm('当前数据为空，是否进行后台查询?', '警告', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.queryParams.type = -1
              getActStageStat(this.queryParams).then(res => {
                this.$message.success('查询请求已经提交5分钟后查看')
              })
            })
          } else {
            this.$message.error('5分钟后再查询')
          }
        } else {
          this.tableData = response.data.data
        }

        this.tableLoad = false
      })
    },
    handleQuery() {
      this.tableLoad = true
      this.queryParams.startDate = this.dateList[0]
      this.queryParams.endDate = this.dateList[1]
      this.fetchData()
    },
    handleChange() {
      this.dateDisabled = true
    },
    querySearchAsync(queryString, cb) {
      if (!queryString) {
        cb([])
        return
      }
      getActivtyList({ id: parseInt(queryString) }).then(res => {
        const results = []
        for (let i = 0; i < res.data.list.length; i++) {
          results.push(res.data.list[i])
        }
        cb(results)
      })
    },
    handleSelect(item) {
      if (item.type != 'super_collect' && item.type != 'rank') {
        Message({ message: '不支持该类型', type: 'error', duration: 5 * 1000 })
      } else {
        const start_time = new Date(item.start_time)
        const endTime = new Date(item.end_time)
        this.dateDisabled = false
        this.queryParams.level = item.id
        this.queryParams.lang = item.type
        this.pickerOptions.disabledDate = time => !(start_time.getTime() - 3600 * 1000 <= time.getTime() && time.getTime() <= endTime.getTime())
      }
    }
  }
}
</script>

<style scoped>
</style>
